import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Input, Popover, InputNumber, Form, Select } from 'antd'
import { setTextBox } from '../../../../../store/actions'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ChromePicker } from 'react-color'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import utils from 'bxl-utils'
import ColorPicker from '../../../../../components/ColorPicker'
const { TextArea } = Input
import { withTranslation } from 'react-i18next'
const mapDispatchToProps = (dispatch, ownProps) => ({
  setText: (key: string, value?: string) => {
    dispatch(setTextBox(ownProps.id, key, value))
  },
})
const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
}

const fontWeightSection = [100, 200, 300, 400, 500, 600, 700, 800, 900]

const alignType = ['left', 'center', 'right']

interface textConfig {
  text?: string
  textColor?: string
  fontSize?: number
  lineHeight?: number
  fontWeight?: number
  textAlign?: string
}
interface TextBoxProps {
  config: textConfig
  id: String
  setText: Function
  t: (str: string) => string
}
class TextBox extends Component<TextBoxProps> {
  changeText = (name, value) => {
    this.props.setText(name, value)
  }
  setColor = rgb => {
    this.props.setText('textColor', rgb)
  }
  selectorFontWeight = value => {
    this.props.setText('fontWeight', value)
  }
  selectorTextAlign = value => {
    this.props.setText('textAlign', value)
  }
  render() {
    const { config, setText, t } = this.props
    const { text, textColor, fontSize, lineHeight, fontWeight, textAlign } = config
    const content = <ColorPicker handleOk={this.setColor} color={textColor}></ColorPicker>
    return (
      <div className="textContent">
        <Form>
          <Form.Item {...formItemLayout} label={t('textContent')}>
            <TextArea
              value={text}
              name="text"
              onChange={e => setText('text', e.target.value)}
              placeholder={t('textContent')}
              autoSize={{ minRows: 2 }}
            ></TextArea>
          </Form.Item>
          <Form.Item {...formItemLayout} label={t('fontSize')}>
            <InputNumber
              className="input-lar-input"
              type="number"
              value={fontSize}
              defaultValue={12}
              name="fontSize"
              onChange={e => setText('fontSize', e)}
            />
          </Form.Item>
          <Form.Item {...formItemLayout} label={t('lineHeight')}>
            <InputNumber
              className="input-lar-input"
              type="number"
              value={lineHeight}
              defaultValue={12}
              name="lineHeight"
              onChange={e => setText('lineHeight', e)}
            />
          </Form.Item>
          <Form.Item {...formItemLayout} label={t('fontColor')}>
            <Popover placement="right" title={t('fontColor')} content={content} trigger="click">
              <div className="colorBtn" style={{ backgroundColor: textColor || '#000' }}></div>
            </Popover>
          </Form.Item>
          <Form.Item {...formItemLayout} label={t('fontWeight')}>
            <Select defaultValue={fontWeight} onChange={this.selectorFontWeight}>
              {fontWeightSection.map(item => (
                <Select.Option value={item} key={item}>
                  {item}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item {...formItemLayout} label={t('alignment')}>
            <Select defaultValue={textAlign} onChange={this.selectorTextAlign}>
              {alignType.map(item => (
                <Select.Option value={item} key={item}>
                  {item}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </div>
    )
  }
}
export default connect(null, mapDispatchToProps)(withTranslation()(TextBox))
